import { matchPath } from 'react-router';

/**
 * The header stays pinned on every screen except the audit form itself
 * (conducting an audit, and the admin Form Preview of it), where the
 * owner wants the full height for the form; there it scrolls away and
 * the form's own sticky sidebar/toolbar takes over.
 */
export function isAuditFormRoute(pathname: string): boolean {
  if (matchPath('/admin/preview', pathname)) return true;
  const conduct = matchPath('/audits/:localId', pathname);
  return conduct !== null && conduct.params.localId !== 'records';
}
